import { Currency } from "types/currency";
import useInputValue, { InputValue } from "types/input-value";


export function useGetCryptoCurrency(cryptoSymbol?: string, suggestedCryptoSymbol?: string): InputValue<Currency> {
    const symbol = cryptoSymbol ?? suggestedCryptoSymbol ?? "USDT"
    const currency: InputValue<Currency>  = useInputValue(undefined, { symbol }, cryptoSymbol !== undefined);
    return currency
}